import { useEffect, useState } from "react";

import { Image } from "@modules/blog/types";

export const useRenderFileViewHook = (newList: FileList | Image | null) => {
  // converting fileList to base64
  const [previews, setPreviews] = useState<string[] | []>([]);

  useEffect(() => {
    const alreadyUploadedImage = !(newList instanceof FileList);

    if (newList === null || alreadyUploadedImage) {
      // Image comes from Db (not first time upload)
      setPreviews([])

      return
    }

    const promises = Object.values(newList).map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onloadend = () => {
          resolve(reader.result);
        };

        reader.readAsDataURL(file);
      });
    });

    Promise.all(promises)
      .then((results: unknown) => {
        if (Array.isArray(results)) {
          setPreviews(results as string[]);
        }
      })
  }, [newList]);

  if (!previews?.length) {
    return [];
  }

  return previews
};
